*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;

  & .dropdown-trigger {
    cursor: not-allowed;
    display: inline-flex;
  }
}
